import { render, staticRenderFns } from "./LeadsDatabase.vue?vue&type=template&id=6eb1b763&scoped=true&"
import script from "./LeadsDatabase.vue?vue&type=script&lang=js&"
export * from "./LeadsDatabase.vue?vue&type=script&lang=js&"
import style0 from "./LeadsDatabase.vue?vue&type=style&index=0&id=6eb1b763&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb1b763",
  null
  
)

export default component.exports